import type { ConditionBuild, ConditionBuildableId, GetNextId } from "@skilitics/nautilus-core-designer-data";

import type { ConditionBuildable } from "../../types/index.ts";
import type { GetConditionBuildable } from "./getConditionBuildable.ts";

type Options = {
  getBuildable: GetConditionBuildable;
  getNextId: GetNextId;
};

export const createConditionCreate =
  ({ getBuildable, getNextId }: Options) =>
  (idOrBuildable: ConditionBuildableId | ConditionBuildable): ConditionBuild | undefined => {
    const createCondition = ({ name, builder, spec, nodeId }: ConditionBuildable): ConditionBuild => {
      const config = builder.getInitialConfig?.(spec) ?? {};

      const createChildCondition = (b: ConditionBuildable<any>) =>
        createCondition({
          ...b,
          nodeId,
        });
      // TODO: condition created here but not added to state (via actions)
      // designer nodes were added with children implicitly
      const children: ConditionBuild["children"] = Object.fromEntries(
        Object.entries(builder.getInitialChildren?.(spec) ?? {})
          .filter((e): e is [string, NonNullable<(typeof e)[1]>] => !!e[1])
          .map(([buildName, buildOrBuilds]) => [
            buildName,
            Array.isArray(buildOrBuilds)
              ? buildOrBuilds.filter((b): b is ConditionBuildable<any> => !!b).map(createChildCondition)
              : buildOrBuilds
                ? createChildCondition(buildOrBuilds)
                : undefined,
          ]),
      );

      return {
        id: getNextId(),
        nodeId,
        buildableName: name,
        config,
        children,
      };
    };

    if (!("builder" in idOrBuildable)) {
      const id = idOrBuildable;
      const buildable = getBuildable(id);
      if (!buildable) {
        console.warn(`No buildable found for node id: ${id.nodeId} and name ${id.name}`);
        return;
      }
      return createCondition(buildable);
    }

    return createCondition(idOrBuildable);
  };

export type CreateCondition = ReturnType<typeof createConditionCreate>;
